// ─────────────────────────────────────────────────────────────────────────────
// graphSourceMode — which source the graph is running on, decided once.
//
// TWO MODES, NEVER MIXED. `synthetic` is the lab (every id `lab:`, every record
// marked synthetic, the renderer stress harness); `live` is Rexy OS's own
// structure (every id `os:`, nothing fabricated). A graph holds one or the other
// for its whole life — a store containing both would make every count, every
// capture and every parity assertion meaningless.
//
// SYNTHETIC IS THE DEFAULT, and that matters for more than convenience: the lab
// surface mounts above the PIN gate, so an unrecognised or absent `source` must
// land on the mode that holds nothing real. Only the explicit string `live` opts
// into the authenticated path.
//
//   ?surface=graphlab                      → synthetic (unchanged, pre-auth)
//   ?surface=graphlab&source=synthetic     → synthetic (explicit, pre-auth)
//   ?surface=graphlab&source=live          → live      (PIN required — App.tsx)
// ─────────────────────────────────────────────────────────────────────────────

export type GraphSourceMode = 'synthetic' | 'live';

export const LIVE_SOURCE_PARAM = 'live';

/**
 * Read from an explicit search string when given, so this is testable without a
 * browser location and so App.tsx and the lab can never disagree about what the
 * URL said.
 */
export function graphSourceModeFrom(search: string): GraphSourceMode {
  const value = new URLSearchParams(search).get('source');
  return value === LIVE_SOURCE_PARAM ? 'live' : 'synthetic';
}

export function currentGraphSourceMode(): GraphSourceMode {
  if (typeof window === 'undefined') return 'synthetic';
  return graphSourceModeFrom(window.location.search);
}

/** Human label for the Dev readout. Never shown outside Dev. */
export function sourceModeLabel(mode: GraphSourceMode): string {
  return mode === 'live' ? 'LIVE REXY OS' : 'SYNTHETIC LAB';
}
